import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption, IAnyStrObject } from 'src/types';
import {
  tranArrayBufferToUint8Array,
  logErrorAndRunFail,
  paramCheck,
  requiredParamsCheck
} from '../../utils';

export interface WriteBLECharacteristicValueOption
  extends Partial<GeneralInvokeOption> {
  deviceId: string;
  serviceId: string;
  characteristicId: string;
  value: ArrayBuffer;
  writeType?: string;
  invalidParamObj?: '';
}

// 向蓝牙低功耗设备特征值中写入二进制数据。注意：必须设备的特征支持 write 才可以成功调用
export function writeBLECharacteristicValue(
  option: WriteBLECharacteristicValueOption
) {
  const { deviceId, serviceId, characteristicId, value, writeType } = option;
  const requiredParamField: IAnyStrObject = { deviceId, serviceId, characteristicId, value };
  writeType !== undefined && (requiredParamField.writeType = writeType);
  if (
    !requiredParamsCheck(
      requiredParamField,
      option,
      APINames.Native.WRITE_BLE_CHARACTERISTIC_VALUE
    )
  ) {
    return option.invalidParamObj;
  }
  if (
    paramCheck(APINames.Native.WRITE_BLE_CHARACTERISTIC_VALUE, option, {
      deviceId: '',
      serviceId: '',
      characteristicId: '',
      value: new ArrayBuffer(8),
      writeType: ''
    })
  ) {
    const validWriteType: Array<string> = [
      'write',
      'writeNoResponse',
      'signedWrite'
    ];
    if (option?.writeType && validWriteType.indexOf(option?.writeType) === -1) {
      return logErrorAndRunFail(
        APINames.Native.WRITE_BLE_CHARACTERISTIC_VALUE,
        option,
        'parameter error:parameter.writeType contains invalid values.'
      );
    }
    const finalValue = tranArrayBufferToUint8Array(option.value);
    const finalOption = {
      ...option,
      value: finalValue
    };
    return MacleJSBridge.beforeInvoke(
      APINames.Native.WRITE_BLE_CHARACTERISTIC_VALUE,
      finalOption
    );
  }
  return option.invalidParamObj;
}
